import { BaseRequestQueryParam, HttpResponse } from 'models';
import axiosClient, { handleRequest } from './axiosClient';
import { AwcGame, Platform, PlayGameRequest, PlayGameResponse } from 'models/casino';
import { getLocalStorage } from 'utils/sessionStorage';

const casinoApi = {
  getPlatform: (): Promise<HttpResponse<Platform[]>> => {
    const url = '/casino/api/games/platforms';
    return handleRequest(axiosClient.get(url));
  },
  getGame: (params?: BaseRequestQueryParam): Promise<HttpResponse<AwcGame[]>> => {
    const url = '/casino/api/games/games';
    return handleRequest(axiosClient.get(url, { params }));
  },
  playGame: (body: PlayGameRequest): Promise<HttpResponse<PlayGameResponse>> => {
    const url = `/casino/api/awc/play-game`;
    return handleRequest(
      axiosClient.post(url, body, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
};

export default casinoApi;
